import { useParams } from 'react-router-dom';
import { Button, Popconfirm, Space } from 'antd';

import { initSnapSuccessAction, snapStore } from 'containers/Snaps/Snap/store';

import { usePutRequest } from 'hooks';

import { SnapDetails, SnapState } from 'codegen';

export const FraudButton = () => {
  const { snapId } = useParams();

  const status = snapStore((state) => state.status);
  const isFraudSuspicious = snapStore((state) => state.snapBooleanStatuses.isFraudSuspicious);

  const [toggleFraud, { loading }] = usePutRequest<SnapDetails>({
    options: {
      onSuccess: ({ data }) => initSnapSuccessAction(data),
    },
  });

  const isFraud = status === SnapState.RECEIPT_FRAUD;

  const nonFraud = (
    <Button
      className='border-[green] text-[green]'
      size='small'
      loading={loading}
      onClick={() => toggleFraud({
        callbackURL: `/snaps/details/${snapId}/non-fraud`,
      })}
    >
      Not Fraud
    </Button>
  );

  const fraud = (
    <Popconfirm
      title={(
        <div className='w-[200px]'>
          Are you sure you want to mark this snap as fraud? Its collector will be marked fraudster automatically.
        </div>
      )}
      okText='Yes'
      cancelText='No'
      placement='bottom'
      onConfirm={() => toggleFraud({
        callbackURL: `/snaps/details/${snapId}/fraud`,
      })}
    >
      <Button
        danger
        size='small'
        loading={loading}
      >
        Fraud
      </Button>
    </Popconfirm>
  );

  if (isFraudSuspicious) {
    return (
      <Space size={10}>
        {nonFraud}

        {fraud}
      </Space>
    );
  }

  if (isFraud) {
    return nonFraud;
  }

  return fraud;
};
